var _circle, _path, _circle2, _circle3, _path2, _circle4, _circle5, _path3, _circle6, _circle7, _path4, _circle8, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 461,
    viewBox: "0 0 682 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5215,
    cy: 364.721,
    r: 46.8291,
    fill: "#BBCFFD",
    stroke: "#7B99CE",
    strokeWidth: 1.62122
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7054 395.618C18.313 393.058 18.313 389.119 20.7054 386.558C29.4001 377.253 41.7813 371.437 55.521 371.437C69.2606 371.437 81.6418 377.253 90.3365 386.558C92.7289 389.119 92.7289 393.058 90.3365 395.618C81.6418 404.923 69.2606 410.739 55.521 410.739C41.7813 410.739 29.4001 404.923 20.7054 395.618Z",
    fill: "#708BBF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5211,
    cy: 342.092,
    r: 17.8649,
    fill: "#708BBF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.161,
    cy: 90.065,
    r: 38.7675,
    fill: "#BFF3DA",
    stroke: "#7BCE8D",
    strokeWidth: 1.34213
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.339 115.643C164.358 113.523 164.358 110.262 166.339 108.143C173.537 100.44 183.787 95.6245 195.161 95.6245C206.535 95.6245 216.785 100.44 223.983 108.143C225.964 110.262 225.964 113.523 223.983 115.643C216.785 123.346 206.535 128.161 195.161 128.161C183.787 128.161 173.537 123.346 166.339 115.643Z",
    fill: "#70BFBA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.162,
    cy: 71.3314,
    r: 14.7894,
    fill: "#70BFBA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.677,
    cy: 363.062,
    r: 36.3838,
    fill: "#F3DEBE",
    stroke: "#CEA87B",
    strokeWidth: 1.25961
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.627 387.067C368.769 385.078 368.769 382.017 370.627 380.028C377.383 372.798 387.002 368.279 397.677 368.279C408.352 368.279 417.972 372.798 424.727 380.028C426.586 382.017 426.586 385.078 424.727 387.067C417.972 394.296 408.352 398.815 397.677 398.815C387.002 398.815 377.383 394.296 370.627 387.067Z",
    fill: "#BF8770"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.676,
    cy: 345.48,
    r: 13.8801,
    fill: "#BF8770"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.696,
    cy: 188.888,
    r: 46.8291,
    fill: "#E5D6E9",
    stroke: "#A07BCE",
    strokeWidth: 1.62122
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.879 219.785C541.487 217.225 541.487 213.286 543.879 210.725C552.574 201.42 564.955 195.604 578.695 195.604C592.434 195.604 604.816 201.42 613.51 210.725C615.903 213.286 615.903 217.225 613.51 219.785C604.816 229.09 592.434 234.907 578.695 234.907C564.955 234.907 552.574 229.09 543.879 219.785Z",
    fill: "#9770BF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.696,
    cy: 166.259,
    r: 17.8649,
    fill: "#9770BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.792 208.267L193.792 209.302L194.828 209.302L194.828 208.267L193.792 208.267ZM188.268 132.531C188.229 135.581 190.669 138.084 193.718 138.124C196.768 138.163 199.272 135.723 199.311 132.674C199.35 129.624 196.91 127.121 193.861 127.081C190.811 127.042 188.308 129.482 188.268 132.531ZM50.6433 319.172C50.604 322.221 53.0441 324.725 56.0934 324.764C59.1427 324.803 61.6464 322.363 61.6857 319.314C61.7249 316.265 59.2848 313.761 56.2356 313.722C53.1863 313.682 50.6825 316.122 50.6433 319.172ZM56.1574 208.266L56.1574 207.231L55.1221 207.231L55.1221 208.267L56.1574 208.266ZM194.828 208.267L194.825 132.602L192.754 132.603L192.757 208.267L194.828 208.267ZM57.1998 319.243L57.1927 208.266L55.1221 208.267L55.1292 319.243L57.1998 319.243ZM56.1574 209.302L193.792 209.302L193.792 207.231L56.1574 207.231L56.1574 209.302Z",
    fill: "#A2BFF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.238 366.099L184.238 367.135L184.238 366.099ZM98.9098 366.012C98.8705 369.061 101.311 371.565 104.36 371.604C107.409 371.644 109.913 369.204 109.952 366.154C109.991 363.105 107.551 360.601 104.502 360.562C101.453 360.523 98.949 362.963 98.9098 366.012ZM354.452 366.064C354.413 369.114 356.853 371.617 359.902 371.657C362.951 371.696 365.455 369.256 365.495 366.207C365.534 363.157 363.094 360.654 360.044 360.614C356.995 360.575 354.491 363.015 354.452 366.064ZM264.783 366.116L264.783 365.08L264.783 365.08L264.783 366.116ZM184.238 365.064L104.431 365.048L104.431 367.118L184.238 367.135L184.238 365.064ZM359.974 365.1L264.783 365.08L264.783 367.151L359.973 367.171L359.974 365.1ZM264.783 365.08L184.238 365.064L184.238 367.135L264.783 367.151L264.783 365.08Z",
    fill: "#A2BFF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M530.974 369.041L530.974 370.076L530.974 370.076L530.974 369.041ZM429.479 368.929C429.44 371.978 431.88 374.482 434.929 374.521C437.978 374.561 440.482 372.12 440.521 369.071C440.561 366.022 438.12 363.518 435.071 363.479C432.022 363.44 429.518 365.88 429.479 368.929ZM576.692 237.02C576.653 240.07 579.093 242.573 582.142 242.613C585.191 242.652 587.695 240.212 587.734 237.163C587.774 234.113 585.333 231.61 582.284 231.57C579.235 231.531 576.731 233.971 576.692 237.02ZM582.259 369.053L582.259 370.089L583.295 370.089L583.294 369.053L582.259 369.053ZM530.975 368.006L435.001 367.965L435 370.035L530.974 370.076L530.975 368.006ZM581.178 237.092L581.224 369.054L583.294 369.053L583.248 237.091L581.178 237.092ZM582.259 368.018L530.975 368.006L530.974 370.076L582.259 370.089L582.259 368.018Z",
    fill: "#A2BFF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.516 90.7616L377.515 91.7969L377.516 90.7616ZM229.901 90.6759C229.861 93.7252 232.301 96.2289 235.351 96.2682C238.4 96.3075 240.904 93.8674 240.943 90.8181C240.982 87.7688 238.542 85.2651 235.493 85.2258C232.444 85.1865 229.94 87.6266 229.901 90.6759ZM575.125 139.051C575.086 142.1 577.526 144.604 580.575 144.643C583.624 144.682 586.128 142.242 586.167 139.193C586.207 136.144 583.767 133.64 580.717 133.601C577.668 133.561 575.164 136.002 575.125 139.051ZM580.641 90.7824L581.677 90.7823L581.676 89.7472L580.641 89.7471L580.641 90.7824ZM377.516 89.7263L235.422 89.7117L235.422 91.7823L377.515 91.7969L377.516 89.7263ZM581.682 139.122L581.677 90.7823L579.606 90.7825L579.611 139.122L581.682 139.122ZM580.641 89.7471L377.516 89.7263L377.515 91.7969L580.641 91.8177L580.641 89.7471Z",
    fill: "#A2BFF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.3863,
    cy: 196.016,
    r: 75.6657,
    fill: "white",
    stroke: "#5170DF",
    strokeWidth: 1.44125
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.592 226.282H27.2888C26.3472 226.281 25.4444 225.906 24.7786 225.241C24.1128 224.575 23.7383 223.672 23.7373 222.73V167.86C23.7384 166.918 24.1129 166.016 24.7787 165.35C25.4445 164.684 26.3472 164.309 27.2888 164.308H135.592C136.534 164.309 137.436 164.684 138.102 165.35C138.768 166.015 139.142 166.918 139.143 167.86V222.73C139.142 223.672 138.768 224.575 138.102 225.241C137.436 225.906 136.534 226.281 135.592 226.282Z",
    fill: "#0022DE"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.5005 176.756H36.3919C36.0746 176.756 35.8174 177.013 35.8174 177.33V217.609C35.8174 217.926 36.0746 218.183 36.3919 218.183H38.5005C38.8178 218.183 39.075 217.926 39.075 217.609V177.33C39.075 177.013 38.8178 176.756 38.5005 176.756Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2417 189.767H33.1331C32.8158 189.767 32.5586 190.024 32.5586 190.342V217.609C32.5586 217.926 32.8158 218.183 33.1331 218.183H35.2417C35.559 218.183 35.8162 217.926 35.8162 217.609V190.342C35.8162 190.024 35.559 189.767 35.2417 189.767Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.5727 212.941H62.4642C62.1469 212.941 61.8896 213.199 61.8896 213.516V217.609C61.8896 217.926 62.1469 218.183 62.4642 218.183H64.5727C64.89 218.183 65.1472 217.926 65.1472 217.609V213.516C65.1472 213.199 64.89 212.941 64.5727 212.941Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3139 187.427H59.2054C58.8881 187.427 58.6309 187.685 58.6309 188.002V217.609C58.6309 217.926 58.8881 218.183 59.2054 218.183H61.3139C61.6312 218.183 61.8884 217.926 61.8884 217.609V188.002C61.8884 187.685 61.6312 187.427 61.3139 187.427Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.5366 193.386H49.428C49.1107 193.386 48.8535 193.643 48.8535 193.961V217.609C48.8535 217.926 49.1107 218.184 49.428 218.184H51.5366C51.8539 218.184 52.1111 217.926 52.1111 217.609V193.961C52.1111 193.643 51.8539 193.386 51.5366 193.386Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2778 201.954H46.1692C45.852 201.954 45.5947 202.211 45.5947 202.529V217.609C45.5947 217.926 45.852 218.183 46.1692 218.183H48.2778C48.5951 218.183 48.8523 217.926 48.8523 217.609V202.529C48.8523 202.211 48.5951 201.954 48.2778 201.954Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.676 184.768H101.568C101.25 184.768 100.993 185.025 100.993 185.342V217.609C100.993 217.926 101.25 218.184 101.568 218.184H103.676C103.994 218.184 104.251 217.926 104.251 217.609V185.342C104.251 185.025 103.994 184.768 103.676 184.768Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.419 197.071H98.3109C97.9936 197.071 97.7363 197.328 97.7363 197.645V217.609C97.7363 217.926 97.9936 218.184 98.3109 218.184H100.419C100.737 218.184 100.994 217.926 100.994 217.609V197.645C100.994 197.328 100.737 197.071 100.419 197.071Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.6059 189.98H75.4974C75.1801 189.98 74.9229 190.237 74.9229 190.555V217.609C74.9229 217.926 75.1801 218.183 75.4974 218.183H77.6059C77.9232 218.183 78.1804 217.926 78.1804 217.609V190.555C78.1804 190.237 77.9232 189.98 77.6059 189.98Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3471 193.173H72.2386C71.9213 193.173 71.6641 193.431 71.6641 193.748V217.609C71.6641 217.926 71.9213 218.183 72.2386 218.183H74.3471C74.6644 218.183 74.9217 217.926 74.9217 217.609V193.748C74.9217 193.431 74.6644 193.173 74.3471 193.173Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.6391 176.756H88.5306C88.2133 176.756 87.9561 177.013 87.9561 177.33V217.609C87.9561 217.926 88.2133 218.183 88.5306 218.183H90.6391C90.9564 218.183 91.2136 217.926 91.2136 217.609V177.33C91.2136 177.013 90.9564 176.756 90.6391 176.756Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3833 178.751H85.2747C84.9574 178.751 84.7002 179.009 84.7002 179.326V217.609C84.7002 217.926 84.9574 218.184 85.2747 218.184H87.3833C87.7006 218.184 87.9578 217.926 87.9578 217.609V179.326C87.9578 179.009 87.7006 178.751 87.3833 178.751Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.709 176.755H114.601C114.284 176.755 114.026 177.013 114.026 177.33V217.609C114.026 217.926 114.284 218.183 114.601 218.183H116.709C117.027 218.183 117.284 217.926 117.284 217.609V177.33C117.284 177.013 117.027 176.755 116.709 176.755Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.453 189.767H111.344C111.027 189.767 110.77 190.024 110.77 190.342V217.609C110.77 217.926 111.027 218.183 111.344 218.183H113.453C113.77 218.183 114.027 217.926 114.027 217.609V190.342C114.027 190.024 113.77 189.767 113.453 189.767Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.746 193.386H127.637C127.32 193.386 127.062 193.643 127.062 193.961V217.609C127.062 217.926 127.32 218.184 127.637 218.184H129.746C130.063 218.184 130.32 217.926 130.32 217.609V193.961C130.32 193.643 130.063 193.386 129.746 193.386Z",
    fill: "#5D6ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.489 201.954H124.38C124.063 201.954 123.806 202.211 123.806 202.529V217.609C123.806 217.926 124.063 218.183 124.38 218.183H126.489C126.806 218.183 127.063 217.926 127.063 217.609V202.529C127.063 202.211 126.806 201.954 126.489 201.954Z",
    fill: "#5D6ECC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 234.158,
    cy: 366.084,
    r: 56.9294,
    fill: "#F2F4FF",
    stroke: "#5170DF",
    strokeWidth: 1.44125
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.679 346.43L207.263 393.822C207.366 394.878 208.253 395.684 209.315 395.684H263.169C264.336 395.684 265.27 394.716 265.228 393.549L263.623 348.853C263.584 347.782 262.731 346.92 261.661 346.869L204.828 344.174C203.574 344.114 202.559 345.181 202.679 346.43Z",
    fill: "#788DB7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.242 368.996H226.954C226.515 368.995 226.091 368.835 225.761 368.546L217.816 361.539C217.543 361.298 217.192 361.165 216.828 361.165H209.972V337.518C209.972 337.067 210.151 336.635 210.47 336.316C210.789 335.997 211.221 335.818 211.672 335.817H244.542C244.993 335.818 245.425 335.997 245.743 336.316C246.062 336.635 246.242 337.067 246.242 337.518L246.242 368.996Z",
    fill: "#F3F5FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.035 347.873H216.248C216.059 347.873 215.878 347.807 215.744 347.69C215.611 347.574 215.535 347.415 215.535 347.25V341.283C215.535 341.118 215.611 340.96 215.744 340.843C215.878 340.726 216.059 340.66 216.248 340.66H222.035C222.224 340.66 222.405 340.726 222.539 340.843C222.673 340.96 222.748 341.118 222.748 341.283V347.25C222.748 347.415 222.673 347.574 222.539 347.69C222.405 347.807 222.224 347.873 222.035 347.873Z",
    fill: "#7B99CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.867 341.253H225.17C225.047 341.253 224.929 341.302 224.842 341.388C224.755 341.475 224.706 341.593 224.706 341.716C224.706 341.839 224.755 341.957 224.842 342.044C224.929 342.131 225.047 342.18 225.17 342.18H231.867C231.99 342.18 232.108 342.131 232.195 342.044C232.282 341.957 232.331 341.839 232.331 341.716C232.331 341.593 232.282 341.475 232.195 341.388C232.108 341.302 231.99 341.253 231.867 341.253Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59 344.19H225.081C224.874 344.19 224.706 344.398 224.706 344.653C224.706 344.909 224.874 345.117 225.081 345.117H241.59C241.797 345.117 241.965 344.909 241.965 344.653C241.965 344.398 241.797 344.19 241.59 344.19Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.293 350.398H215.92C215.722 350.398 215.562 350.606 215.562 350.861C215.562 351.117 215.722 351.325 215.92 351.325H240.293C240.491 351.325 240.652 351.117 240.652 350.861C240.652 350.606 240.491 350.398 240.293 350.398Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.293 353.283H215.92C215.722 353.283 215.562 353.491 215.562 353.747C215.562 354.002 215.722 354.21 215.92 354.21H240.293C240.491 354.21 240.652 354.002 240.652 353.747C240.652 353.491 240.491 353.283 240.293 353.283Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.293 356.168H215.92C215.722 356.168 215.562 356.376 215.562 356.632C215.562 356.887 215.722 357.096 215.92 357.096H240.293C240.491 357.096 240.652 356.887 240.652 356.632C240.652 356.376 240.491 356.168 240.293 356.168Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.293 359.053H215.92C215.722 359.053 215.562 359.261 215.562 359.517C215.562 359.772 215.722 359.981 215.92 359.981H240.293C240.491 359.981 240.652 359.772 240.652 359.517C240.652 359.261 240.491 359.053 240.293 359.053Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddd_1692_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.214 367.039H226.954C226.603 367.039 226.26 366.937 225.967 366.744L225.943 366.729V342.67C225.944 342.219 226.123 341.787 226.442 341.468C226.761 341.149 227.193 340.97 227.644 340.969H260.514C260.964 340.97 261.396 341.149 261.715 341.468C262.034 341.787 262.213 342.219 262.214 342.67L262.214 367.039Z",
    fill: "#D1E5FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.802 353.747H232.015C231.826 353.747 231.644 353.681 231.511 353.564C231.377 353.448 231.302 353.289 231.302 353.124V347.157C231.302 346.992 231.377 346.834 231.511 346.717C231.644 346.6 231.826 346.534 232.015 346.534H237.802C237.991 346.534 238.172 346.6 238.306 346.717C238.439 346.834 238.514 346.992 238.515 347.157V353.124C238.514 353.289 238.439 353.448 238.306 353.564C238.172 353.681 237.991 353.747 237.802 353.747Z",
    fill: "#7B99CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.84 347.539H241.142C241.019 347.539 240.901 347.587 240.815 347.674C240.728 347.761 240.679 347.879 240.679 348.002C240.679 348.125 240.728 348.243 240.815 348.33C240.901 348.417 241.019 348.466 241.142 348.466H247.84C247.963 348.466 248.081 348.417 248.168 348.33C248.255 348.243 248.304 348.125 248.304 348.002C248.304 347.879 248.255 347.761 248.168 347.674C248.081 347.587 247.963 347.539 247.84 347.539Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.563 350.063H241.054C240.847 350.063 240.679 350.271 240.679 350.527C240.679 350.782 240.847 350.99 241.054 350.99H257.563C257.77 350.99 257.938 350.782 257.938 350.527C257.938 350.271 257.77 350.063 257.563 350.063Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.264 355.55H231.891C231.693 355.55 231.532 355.758 231.532 356.014C231.532 356.269 231.693 356.477 231.891 356.477H256.264C256.462 356.477 256.623 356.269 256.623 356.014C256.623 355.758 256.462 355.55 256.264 355.55Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.264 358.023H231.891C231.693 358.023 231.532 358.231 231.532 358.487C231.532 358.742 231.693 358.95 231.891 358.95H256.264C256.462 358.95 256.623 358.742 256.623 358.487C256.623 358.231 256.462 358.023 256.264 358.023Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.264 360.908H231.891C231.693 360.908 231.532 361.116 231.532 361.372C231.532 361.627 231.693 361.835 231.891 361.835H256.264C256.462 361.835 256.623 361.627 256.623 361.372C256.623 361.116 256.462 360.908 256.264 360.908Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.264 363.793H231.891C231.693 363.793 231.532 364.001 231.532 364.257C231.532 364.512 231.693 364.721 231.891 364.721H256.264C256.462 364.721 256.623 364.512 256.623 364.257C256.623 364.001 256.462 363.793 256.264 363.793Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.199 352.407H262.211C263.349 352.407 264.274 353.315 264.288 354.453C264.414 364.461 265.252 393.186 265.251 396.045C265.251 396.303 208.476 396.579 207.342 396.045C206.904 395.839 206.827 361.475 207.342 360.238C207.857 359.002 243.458 360.29 245.107 360.238C246.327 360.2 251.026 355.745 253.721 353.026C254.112 352.631 254.642 352.407 255.199 352.407Z",
    fill: "#A1BEF6"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddd_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 422.966,
    cy: 76.0625,
    r: 71.3419,
    fill: "#F2F4FF",
    stroke: "#5170DF",
    strokeWidth: 1.44125
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddd_1692_4327)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.26,
    y: 34.2664,
    width: 63.415,
    height: 84.9848,
    rx: 4.31395,
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 34.4821,
    width: 62.9836,
    height: 84.5534,
    rx: 4.09825,
    stroke: "#C6D9FF",
    strokeWidth: 0.431395
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.488 57.1367H425.462C425.079 57.1367 424.712 56.9848 424.442 56.7144C424.171 56.4439 424.02 56.0771 424.02 55.6946C424.02 55.3121 424.171 54.9453 424.442 54.6748C424.712 54.4044 425.079 54.2524 425.462 54.2524H443.488C443.87 54.2524 444.237 54.4044 444.508 54.6748C444.778 54.9453 444.93 55.3121 444.93 55.6946C444.93 56.0771 444.778 56.4439 444.508 56.7144C444.237 56.9848 443.87 57.1367 443.488 57.1367Z",
    fill: "#D6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.488 64.7078H425.462C425.079 64.7078 424.712 64.5559 424.442 64.2854C424.171 64.0149 424.02 63.6481 424.02 63.2656C424.02 62.8832 424.171 62.5163 424.442 62.2459C424.712 61.9754 425.079 61.8235 425.462 61.8235H443.488C443.87 61.8235 444.237 61.9754 444.508 62.2459C444.778 62.5163 444.93 62.8832 444.93 63.2656C444.93 63.6481 444.778 64.0149 444.508 64.2854C444.237 64.5559 443.87 64.7078 443.488 64.7078Z",
    fill: "#D6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.731 67.915H402.886C402.434 67.9145 402 67.7574 401.681 67.4781C401.361 67.1988 401.181 66.8201 401.181 66.425V52.1491C401.181 51.7541 401.361 51.3754 401.681 51.096C402 50.8167 402.434 50.6596 402.886 50.6592H416.731C417.183 50.6596 417.617 50.8167 417.936 51.096C418.256 51.3754 418.436 51.7541 418.436 52.1491V66.425C418.436 66.8201 418.256 67.1988 417.936 67.4781C417.617 67.7574 417.183 67.9145 416.731 67.915Z",
    fill: "#9FB3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.362 80.2102H402.623C402.24 80.2102 401.874 80.0583 401.603 79.7878C401.333 79.5174 401.181 79.1506 401.181 78.7681C401.181 78.3856 401.333 78.0188 401.603 77.7483C401.874 77.4779 402.24 77.3259 402.623 77.3259H443.362C443.551 77.3259 443.739 77.3632 443.914 77.4357C444.089 77.5082 444.248 77.6144 444.382 77.7483C444.516 77.8822 444.622 78.0412 444.694 78.2162C444.767 78.3912 444.804 78.5787 444.804 78.7681C444.804 78.9575 444.767 79.145 444.694 79.32C444.622 79.4949 444.516 79.6539 444.382 79.7878C444.248 79.9217 444.089 80.028 443.914 80.1005C443.739 80.1729 443.551 80.2102 443.362 80.2102Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.362 87.781H402.623C402.24 87.781 401.874 87.6291 401.603 87.3586C401.333 87.0882 401.181 86.7214 401.181 86.3389C401.181 85.9564 401.333 85.5896 401.603 85.3191C401.874 85.0487 402.24 84.8967 402.623 84.8967H443.362C443.744 84.8967 444.111 85.0487 444.382 85.3191C444.652 85.5896 444.804 85.9564 444.804 86.3389C444.804 86.7214 444.652 87.0882 444.382 87.3586C444.111 87.6291 443.744 87.781 443.362 87.781Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.362 95.3521H402.623C402.24 95.3521 401.874 95.2001 401.603 94.9297C401.333 94.6592 401.181 94.2924 401.181 93.9099C401.181 93.5275 401.333 93.1606 401.603 92.8902C401.874 92.6197 402.24 92.4678 402.623 92.4678H443.362C443.744 92.4678 444.111 92.6197 444.382 92.8902C444.652 93.1606 444.804 93.5275 444.804 93.9099C444.804 94.2924 444.652 94.6592 444.382 94.9297C444.111 95.2001 443.744 95.3521 443.362 95.3521Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.362 102.923H402.623C402.24 102.923 401.874 102.771 401.603 102.501C401.333 102.231 401.181 101.864 401.181 101.481C401.181 101.099 401.333 100.732 401.603 100.461C401.874 100.191 402.24 100.039 402.623 100.039H443.362C443.744 100.039 444.111 100.191 444.382 100.461C444.652 100.732 444.804 101.099 444.804 101.481C444.804 101.864 444.652 102.231 444.382 102.501C444.111 102.771 443.744 102.923 443.362 102.923Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450.351,
    cy: 38.5898,
    r: 18.7363,
    fill: "#C7F5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.358 39.4521L443.613 37.0644L447.328 40.5133L456.878 31.0952L459.399 33.7482L447.328 45.952L441.358 39.4521Z",
    fill: "#638497"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ddd_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 590.148,
    cy: 367.525,
    r: 85.7544,
    fill: "#F2F4FF",
    stroke: "#5170DF",
    strokeWidth: 1.44125
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.409 357.291C522.409 351.003 527.506 345.906 533.794 345.906H622.974C629.261 345.906 634.358 351.003 634.358 357.291V369.055H533.794C527.506 369.055 522.409 363.958 522.409 357.67V357.291Z",
    fill: "#E5E9FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.963,
    y: 355.963,
    width: 32.2566,
    height: 3.03591,
    rx: 0.379489,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.015,
    y: 355.963,
    width: 32.2566,
    height: 3.03591,
    rx: 0.379489,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.066,
    y: 355.963,
    width: 32.2566,
    height: 3.03591,
    rx: 0.379489,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.101,
    y: 360.327,
    width: 51.99,
    height: 3.03591,
    rx: 0.379489,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.584,
    y: 352.358,
    width: 45.1592,
    height: 1.51796,
    rx: 0.379489,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.399,
    y: 352.358,
    width: 45.1592,
    height: 1.51796,
    rx: 0.379489,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.508,
    y: 360.327,
    width: 47.8156,
    height: 3.03591,
    rx: 0.379489,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 648.399,
    cy: 357.481,
    r: 9.48723,
    fill: "#A1ACE4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M657.887 384.674C657.887 378.387 652.79 373.29 646.502 373.29H557.322C551.035 373.29 545.937 378.387 545.937 384.674V396.439H646.502C652.79 396.439 657.887 391.342 657.887 385.054V384.674Z",
    fill: "#E5E9FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.2566,
    height: 3.03591,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 653.333 383.346)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.2566,
    height: 3.03591,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 617.281 383.346)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.2566,
    height: 3.03591,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 581.229 383.346)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.99,
    height: 3.03591,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 652.194 387.711)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.1592,
    height: 1.51796,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 653.712 379.741)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.1592,
    height: 1.51796,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 605.896 379.742)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.8156,
    height: 3.03591,
    rx: 0.379489,
    transform: "matrix(-1 0 0 1 596.789 387.711)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_1692_4327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.48723,
    cy: 9.48723,
    r: 9.48723,
    transform: "matrix(-1 0 0 1 541.384 375.377)",
    fill: "#A1ACE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1692_4327",
    x: 0,
    y: 115.63,
    width: 162.772,
    height: 163.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1692_4327",
    result: "effect2_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1692_4327",
    result: "effect3_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_1692_4327",
    x: 171.508,
    y: 304.434,
    width: 125.3,
    height: 126.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1692_4327",
    result: "effect2_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1692_4327",
    result: "effect3_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1692_4327",
    x: 200.3,
    y: 333.86,
    width: 67.3209,
    height: 65.2726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.412163
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780937 0 0 0 0 0.853029 0 0 0 0 0.991667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1692_4327",
    x: 209.456,
    y: 335.302,
    width: 37.3009,
    height: 34.2096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.257602
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddd_1692_4327",
    x: 225.428,
    y: 340.557,
    width: 37.3009,
    height: 27.2028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.206081
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.206081
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.309122
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.206081
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1692_4327",
    result: "effect2_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.103041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.257602
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1692_4327",
    result: "effect3_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddd_1692_4327",
    x: 345.903,
    y: 0,
    width: 154.125,
    height: 155.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1692_4327",
    result: "effect2_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1692_4327",
    result: "effect3_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddd_1692_4327",
    x: 389.103,
    y: 32.5408,
    width: 67.729,
    height: 89.7302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.862789
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.862789
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.29418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.862789
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1692_4327",
    result: "effect2_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.431395
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07849
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1692_4327",
    result: "effect3_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1692_4327",
    x: 428.616,
    y: 19.8535,
    width: 43.4683,
    height: 43.468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.9978
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.225486 0 0 0 0 0.795833 0 0 0 0 0.350963 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ddd_1692_4327",
    x: 498.673,
    y: 277.05,
    width: 182.95,
    height: 183.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1692_4327",
    result: "effect2_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1692_4327",
    result: "effect3_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1692_4327",
    x: 520.891,
    y: 345.906,
    width: 114.985,
    height: 26.1848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.758978
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.257682 0 0 0 0 0.214844 0 0 0 0 0.520833 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1692_4327",
    x: 637.015,
    y: 346.096,
    width: 22.7695,
    height: 22.7693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948722
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0576041 0 0 0 0 0.33394 0 0 0 0 0.658333 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1692_4327",
    x: 544.42,
    y: 373.29,
    width: 114.985,
    height: 26.1848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.758978
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.257682 0 0 0 0 0.214844 0 0 0 0 0.520833 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1692_4327",
    x: 520.512,
    y: 373.48,
    width: 22.7695,
    height: 22.7693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948722
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0576041 0 0 0 0 0.33394 0 0 0 0 0.658333 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_4327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_4327",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/collaboration.530f9b99fbc17a39e7d2b57ab1c15477.svg";
export { ForwardRef as ReactComponent };